import { render } from "./Plans.vue?vue&type=template&id=7ffc42e3&scoped=true"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7ffc42e3"

export default script